/**
 * 전장 조준 헬퍼 — Phaser-free 순수 함수.
 *
 * BattlefieldRunner의 findNearestBrick / collectAimCandidates를 추출.
 * 구조적 타입만 사용해 단위테스트에 Phaser 불필요.
 */

/** 위치를 가진 최소 구조 (Brick-like). */
export interface Locatable {
  readonly x: number;
  readonly y: number;
  readonly active: boolean;
}

/** 그리드 좌표까지 가진 구조 (AimCandidate 생성용). */
export interface GridLocatable extends Locatable {
  readonly gridX: number;
  readonly gridY: number;
}

/** 활성 객체 중 (x,y)에 가장 가까운 점을 반환. 없으면 null. */
export function findNearestPoint(
  x: number,
  y: number,
  items: Iterable<Locatable>,
): { x: number; y: number } | null {
  let bestX = 0;
  let bestY = 0;
  let bestDist = Infinity;
  for (const b of items) {
    if (!b.active) continue;
    const dx = x - b.x;
    const dy = y - b.y;
    const d = dx * dx + dy * dy; // 비교만이므로 sqrt 생략
    if (d < bestDist) {
      bestDist = d;
      bestX = b.x;
      bestY = b.y;
    }
  }
  return bestDist < Infinity ? { x: bestX, y: bestY } : null;
}

/** 활성 객체를 AimCandidate 배열로 수집. id = `${gridX},${gridY}`. */
export function collectAimCandidates(
  items: Iterable<GridLocatable>,
): { id: string; x: number; y: number }[] {
  const out: { id: string; x: number; y: number }[] = [];
  for (const b of items) {
    if (!b.active) continue;
    out.push({ id: `${b.gridX},${b.gridY}`, x: b.x, y: b.y });
  }
  return out;
}
